
export enum InvoiceDocumentCd {
	INDIVIDUAL = 'Individual',
	INVOICE = 'Invoice',
	MANIFEST = 'Manifest',
	NONE = 'None',
	STATEMENT = 'Statement'}

